<script setup>
defineProps({
  items: { type: Array, required: true }
})
</script>

<template>
  <nav class="crumb" aria-label="Breadcrumb">
    <template v-for="(item, i) in items" :key="i">
      <span v-if="i === items.length - 1" class="cur">{{ item[0] }}</span>
      <template v-else>
        <NuxtLink :to="ftHref(item[1])">{{ item[0] }}</NuxtLink>
        <span class="sep">/</span>
      </template>
    </template>
  </nav>
</template>
